import { Button, Form, notification } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDebouncedCallback } from 'use-debounce';

import SubHeader from '../../../components/SubHeader';
import { showErrors } from '../../../helpers/form';
import {
  removeMoedaMask,
  removeThousandSeparatorMask,
} from '../../../helpers/formatador';
import { useAuth } from '../../../security/authContext';
import apiNetCore from '../../../services/apiNetCore';
import { Tabs } from '../../../styles/global';
import DirecionamentoEnum from '../../Demanda/Enum/DirecionamentoEnum';
import ClienteOrigemDestino from './ClienteOrigemDestino';
import DadosGerais from './DadosGerais';
import { Card, Footer } from './styles';
import ValoresLote from './ValoresLote';

const { TabPane } = Tabs;

export default function CadastroLote() {
  const { user } = useAuth();
  const { loteId } = useParams();
  const history = useHistory();
  const [form] = Form.useForm();

  const [currentTab, setCurrentTab] = useState(1);
  const [currentStep, setCurrentStep] = useState(0);
  const [freteInserido, setFreteInserido] = useState('motorista');
  const [dadosPagador, setDadosPagador] = useState({});
  const [loading, setLoading] = useState(false);
  const [disableNext, setDisableNext] = useState(true);
  const [editingLote, setEditingLote] = useState(false);
  const [disableField, setDisableField] = useState(false);
  const [isMarketplace, setIsMarketplace] = useState(true);
  const [dadosLote, setDadosLote] = useState({});
  const [disabledTabs, setDisabledTabs] = useState({
    tab1: true,
    tab2: true,
    tab3: true,
  });

  const tabs = [
    {
      key: '1',
      title: 'Dados gerais',
      content: (
        <DadosGerais
          dadosPagador={dadosPagador}
          setDadosPagador={setDadosPagador}
          form={form}
          disableField={disableField}
          isMarketplace={isMarketplace}
          dadosLote={dadosLote}
          editingLote={editingLote}
        />
      ),
    },
    {
      key: '2',
      title: 'Cliente origem e destino',
      content: (
        <ClienteOrigemDestino
          currentStep={currentStep}
          form={form}
          disableField={disableField}
          isMarketplace={isMarketplace}
          dadosLote={dadosLote}
        />
      ),
    },
    {
      key: '3',
      title: 'Valores de lote',
      content: (
        <ValoresLote
          form={form}
          currentTab={currentTab}
          setFreteInserido={setFreteInserido}
          freteInserido={freteInserido}
          editingLote={editingLote}
          dadosPagador={dadosPagador}
          isMarketplace={isMarketplace}
        />
      ),
    },
  ];

  const breadcrumbs = [
    {
      path: '/demandas',
      breadcrumbName: 'Lotes',
    },
    {
      breadcrumbName: tabs[currentTab - 1].title,
    },
  ];

  const tabsFields = [
    ['cnpjPagador', 'produto', 'especie', 'dataInicio'],
    [],
    ['volume', 'cadencia', 'freteMotoristaPj', 'freteTotalPj'],
  ];

  const stepsFields = [
    ['cidadeOrigem'],
    ['cidadeDestino'],
    ['cidadeExpedidor', 'cepExpedidor', 'enderecoExpedidor', 'bairroExpedidor'],
    [],
  ];

  const validateFields = fields => {
    const fieldsValues = Object.values(fields);
    const emptyFields = fieldsValues.filter(value => !value);
    return emptyFields.length !== 0;
  };

  const validateFormDirecionamento = () => {
    const tipoDirecionamento = form.getFieldValue('direcionamento');

    if (
      tipoDirecionamento === DirecionamentoEnum.FROTISTA ||
      tipoDirecionamento === DirecionamentoEnum.GRUPO_FROTISTA
    ) {
      const fields = form.getFieldsValue([
        `direcionadoPara${tipoDirecionamento}`,
      ]);
      const isValid = validateFields(fields);

      return isValid;
    }

    return false;
  };

  const validateForm = async () => {
    const fields =
      currentTab === 2
        ? form.getFieldsValue(stepsFields[currentStep])
        : form.getFieldsValue(tabsFields[currentTab - 1]);

    const isValid = validateFields(fields);

    const isDirecionamentoValid = validateFormDirecionamento();

    setDisableNext(isValid || isDirecionamentoValid);

    return isValid || isDirecionamentoValid;
  };

  const disableTabs = () => {
    for (let i = 1; i <= 3; i += 1) {
      const fieldsValue = form.getFieldsValue(tabsFields[i - 1]);

      const disable =
        Object.values(fieldsValue).filter(value => !value).length !== 0;

      disabledTabs[`tab${i}`] = disable;
      setDisabledTabs(disabledTabs);
    }
  };

  const validateFormDebounced = useDebouncedCallback(validateForm, 300);

  useEffect(() => {
    validateFormDebounced();
  }, [currentTab, currentStep]);

  function formatarEnderecoExpedidor(allFormValues) {
    if (allFormValues.cepExpedidor) {
      return {
        enderecoExpedidor: allFormValues.enderecoExpedidor,
        complementoEnderecoExpedidor: allFormValues.complementoExpedidor,
        numeroEnderecoExpedidor: allFormValues.numeroExpedidor,
        cepEnderecoExpedidor: allFormValues.cepExpedidor,
        bairroExpedidor: allFormValues.bairroExpedidor,
      };
    }
    return null;
  }

  useEffect(() => {
    async function onInit() {
      if (!loteId) return;
      setEditingLote(true);

      const { data } = await apiNetCore.get(`/lotes-integracao/${loteId}`);

      if (!data) return history.push('/demandas');

      const lote = {
        ...data,
        cnpjPagador: data.dadoPagador.id,
        descricaoProduto: data.produtoNome,
        dataInicio: moment(data.dataInicio),
        dataFim: data.dataFim && moment(data.dataFim),
        ibgeCidadeOrigem: data.enderecoOrigem.ibgeCidade,
        ibgeCidadeDestino: data.enderecoDestino.ibgeCidade,
        ibgeCidadeExpedidor: data.enderecoExpedidor.ibgeCidade,
        ibgeCidadeRecebedor: data.enderecoRecebedor.ibgeCidade,
      };

      setDadosLote(lote);
      setDadosPagador(lote.dadoPagador);
      setDisableField(!!lote.contrato);
      setIsMarketplace(!!lote.idUsuarioShipper);
      setFreteInserido(lote.baseFreteShipper);

      form.setFieldsValue(lote);
      disableTabs();
    }
    onInit();
  }, [form, loteId]);

  const onTabClickChange = value => setCurrentTab(Number(value));

  const previousStep = () => {
    if (currentTab === 1) return history.push('/demandas');

    if (currentTab === 2 && currentStep !== 0) {
      return setCurrentStep(currentStep - 1);
    }

    setCurrentTab(currentTab - 1);
    disableTabs();
  };

  const nextStep = () => {
    if (currentTab === 2 && currentStep < 3) {
      return setCurrentStep(currentStep + 1);
    }

    setCurrentTab(currentTab + 1);
    disableTabs();
  };

  const handleSubmit = async () => {
    setLoading(true);
    const allFormValues = form.getFieldsValue(true);

    const freteMotoristaPJ = removeMoedaMask(
      allFormValues.freteMotoristaPj || 0
    );
    const freteTotalPJ = removeMoedaMask(allFormValues.freteTotalPj || 0);
    const freteMotoristaPF = removeMoedaMask(
      allFormValues.freteMotoristaPf || 0
    );
    const freteTotalPF = removeMoedaMask(allFormValues.freteTotalPf || 0);

    if (
      !freteMotoristaPJ &&
      !freteTotalPJ &&
      !freteMotoristaPF &&
      !freteTotalPF
    ) {
      notification.warning({
        message: 'Valores de Frete inválidos!',
        description: 'Preenchar pelo menos um valor de frete para continuar.',
      });
      setLoading(false);
      return;
    }

    const enderecoExpedidor = formatarEnderecoExpedidor(allFormValues);

    try {
      const data = {
        // Campos implícitos
        idClienteShipper: dadosPagador.id_cliente_raiz,
        idUsuarioShipper: user.id,

        // Tab 1 - Dados gerais
        idClientePagador: dadosPagador.id,
        idEspecie: allFormValues.especie,
        idProduto: allFormValues.produto,
        idStatus: 1, // carregando
        dataInicio: allFormValues.dataInicio,
        dataFim: allFormValues.dataFim,
        observacoes: allFormValues.observacoes,
        ...(allFormValues.direcionamento === DirecionamentoEnum.FROTISTA && {
          idProprietario: allFormValues.idProprietario,
        }),
        ...(allFormValues.direcionamento ===
          DirecionamentoEnum.GRUPO_FROTISTA && {
          idGrupoFrotista: allFormValues.idGrupoFrotista,
        }),

        // Tab 2 - Cliente origem e destino
        idClienteOrigem: allFormValues.idClienteOrigem,
        idClienteDestino: allFormValues.idClienteDestino,
        idClienteExpedidor: allFormValues.idClienteExpedidor,
        idClienteRecebedor: allFormValues.idClienteRecebedor,

        idCidadeOrigem: allFormValues.cidadeOrigem,
        idCidadeDestino: allFormValues.cidadeDestino,
        idCidadeExpedidor: allFormValues.cidadeExpedidor,
        ...enderecoExpedidor,
        idCidadeRecebedor: allFormValues.cidadeRecebedor,

        idClienteEnderecoOrigem: allFormValues.idEnderecoOrigem,
        idClienteEnderecoDestino: allFormValues.idEnderecoDestino,
        idClienteEnderecoExpedidor: allFormValues.idEnderecoExpedidor,
        idClienteEnderecoRecebedor: allFormValues.idEnderecoRecebedor,

        // Tab 3 - Valores de lote
        volume: removeThousandSeparatorMask(allFormValues.volume),
        cadencia: removeThousandSeparatorMask(allFormValues.cadencia),
        baseFreteShipper: freteInserido,
        pedagioIncluso: allFormValues.pedagio,
        freteMotoristaPJ: freteMotoristaPJ || freteMotoristaPF,
        freteTotalPJ: freteTotalPJ || freteTotalPF,
        freteMotoristaPF: freteMotoristaPF || freteMotoristaPJ,
        freteTotalPF: freteTotalPF || freteTotalPJ,
      };

      if (editingLote) {
        await apiNetCore.put(`/lotes-integracao/${loteId}`, data);
      } else {
        await apiNetCore.post('/lotes-integracao', data);
      }

      notification.success({
        message: 'Tudo certo',
        description: editingLote
          ? 'O lote foi atualizado com sucesso.'
          : 'O lote foi cadastrado com sucesso.',
      });

      history.push('/demandas');
    } catch (error) {
      const errors = error?.response?.data?.errors
        ? Object.values(error?.response?.data?.errors)
        : null;
      showErrors(errors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <SubHeader breadcrumbs={breadcrumbs} />
      <Card bordered={false} className="pt-0 height-85">
        <Form
          layout="vertical"
          noValidate
          onFinish={handleSubmit}
          onFinishFailed={({ errorFields }) =>
            showErrors(errorFields.flatMap(error => error.errors))
          }
          onFieldsChange={validateFormDebounced}
          form={form}
        >
          <Tabs activeKey={currentTab.toString()} onTabClick={onTabClickChange}>
            {tabs.map((item, index) => (
              <TabPane
                tab={item.title}
                key={item.key}
                disabled={disabledTabs[`tab${index + 1}`]}
              >
                {item.content}
              </TabPane>
            ))}
          </Tabs>

          <Footer gutter={12} justify="end">
            <Button
              className="margin-sides"
              onClick={previousStep}
              disabled={loading}
            >
              Voltar
            </Button>
            {currentTab === tabs.length && (
              <Button
                type="primary"
                htmlType="submit"
                disabled={disableNext}
                loading={loading}
              >
                Salvar
              </Button>
            )}
            {currentTab < tabs.length && (
              <Button type="primary" onClick={nextStep} disabled={disableNext}>
                Continuar
              </Button>
            )}
          </Footer>
        </Form>
      </Card>
    </>
  );
}
